import React from 'react';

export const LabRequestContext = React.createContext({
    resetCurrentPage: () => {},
});